import http from "../request";

export interface Qrcode {
  token: string;
  hash: string;
}

export interface QrcodeApi {
  getQrcode: () => Promise<Qrcode>;
}

const qrcodeApi: QrcodeApi = {
  getQrcode() {
    return http.post<Qrcode>("/weixin/qr-code/generate").then((res) => res.data);
  },
};

export default qrcodeApi;
